import * as React from 'react';
import * as styles from "./MyLinks.css";
import { IAButton } from '../button/Button';
import { IACommandBar } from '../commandBar/CommandBar';
import { inject, observer } from 'mobx-react';
import { MyLinksStore } from './stores';
import { MyLink } from './myLink/MyLink';
import { IMyLink } from '../../interfaces/IMyLink';
import { EditPanel } from './editPanel/EditPanel';
import { LocalizationService } from '../../services/LocalizationService';
import { Helper } from '../../Helper';
import { IAPopup } from '../popup/Popup';
import "../../styles/BasicIA.css";
import { IACardViewService } from '../messagesCardView/CardView.service';
import { IASmallMenu, SmallMenuItem } from '../smallMenu/smallMenu';

export interface MyLinksProps {
  myLinksStore?: MyLinksStore;
  onChange: () => void;
}

@inject('myLinksStore')
@observer
export class MyLinks extends React.Component<MyLinksProps, {}> {

  private cardViewService: IACardViewService = new IACardViewService();
  private localizationService = new LocalizationService();
  private cancelPopupId;
  private deletePopupId;
  private webpartId;

  constructor(props: MyLinksProps) {
    super(props);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    this.cancelPopupId = Helper.getRandomStringKey();
    this.deletePopupId = Helper.getRandomStringKey();
    this.webpartId = Helper.getRandomStringKey();
    // Resize
    window.addEventListener('resize', () => this.forceUpdate());
    this.forceUpdate();
    setTimeout(() => {
      this.forceUpdate();
    }, 0);
    try {
      var resizeObserver = new ResizeObserver(() => {
        this.forceUpdate();
      });
      resizeObserver.observe(document.getElementById(`IntraActiveMyLinks_${this.webpartId}`));
    } catch {
      this.forceUpdate();
    }
  }

  public onMenuItemClick(itemTitle: string) {
    switch (itemTitle) {
      case 'CreateNewItem':
        this.props.myLinksStore.createNewItem();
        break
      case "ExitEnterEditMode":
        this.props.myLinksStore.editMode = !this.props.myLinksStore.editMode;
        break;
      default: break;
    }
  }

  public render(): JSX.Element {
    const myLinks = [];
    let containerWidth: number = 0;
    const containerDiv = document.getElementById(`IntraActiveMyLinks_${this.webpartId}`);
    if (containerDiv) {
      containerWidth = containerDiv.clientWidth;
    } else {
      setTimeout(() => {
        this.forceUpdate();
      }, 0);
    }
    let padding = 10;
    let minLinkWidth = 200;
    let displayType = this.props.myLinksStore.displayType;
    if (this.props.myLinksStore.editMode) {
      displayType = "Standard";
    }
    switch (displayType) {
      case "Standard":
        padding = 15;
        minLinkWidth = 210
        break;
      case "Condensed":
        padding = 15;
        minLinkWidth = 210
        break;
      case "Tiles":
        padding = 10;
        minLinkWidth = 110
        break;
      default:
        break;
    }
    const [numberOfCardsPerRow, maxWidthAvailable] = this.cardViewService.getNumberOfCardsPerRowAndMaxCardWidthAvailable(containerWidth, padding, minLinkWidth, 20);
    let currentRowNumber = 1;
    this.props.myLinksStore.myLinks.forEach((myLink: IMyLink, index) => {
      myLinks.push(
        <MyLink
          key={index}
          title={myLink.title}
          url={myLink.url}
          index={index}
          icon={myLink.icon}
          styles={{
            marginRight: currentRowNumber == numberOfCardsPerRow || this.props.myLinksStore.editMode ? 0 : padding,
            marginBottom: padding,
            width: window.innerWidth < 667 || this.props.myLinksStore.editMode ? "100%" : maxWidthAvailable,
            fontFamily: this.props.myLinksStore.fontSlots?.body?.fontFamily
          }}
          onChange={() => this.props.onChange()}
        />
      );
      if (currentRowNumber == numberOfCardsPerRow) {
        currentRowNumber = 1;
      } else {
        currentRowNumber++;
      }
    });
    let collapsedMenuItems: SmallMenuItem[] = [];
    collapsedMenuItems = [
      ...this.props.myLinksStore.collapseCommandBarItems ?
        [{
          translation: this.localizationService.strings.MyLinks_AddButton,
          actionName: 'CreateNewItem',
          icon: 'Add'
        }] : [],
      ...!this.props.myLinksStore.editMode ?
        [{
          translation: this.localizationService.strings.MyLinks_EditButton,
          actionName: 'ExitEnterEditMode',
          icon: 'Edit',
        }] : [],
    ];
    return (
      <div
        className={styles.IA_myLinks}
        id={`IntraActiveMyLinks_${this.webpartId}`}
      >
        <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.props.myLinksStore.showCancelEditPopup &&
            <IAPopup
              headline={this.localizationService.strings.Messages_CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={this.localizationService.strings.Messages_CancelPopup_Yes}
                    buttonColor={this.props.myLinksStore.highlightColor}
                    showSpinner={false}
                    onClick={() => {
                      this.props.myLinksStore.myLinks[this.props.myLinksStore.itemToEditIndex] = this.props.myLinksStore.itemToEditOriginal;
                      this.props.myLinksStore.itemToEditOriginal = undefined;
                      this.props.myLinksStore.itemToEdit = undefined;
                      this.props.myLinksStore.itemToEditIndex = undefined;
                      this.props.myLinksStore.isCreatingNewItem = false;
                      this.props.myLinksStore.showCancelEditPopup = false;
                      document.body.style.overflowY = "auto";
                      document.body.style.height = "inherit";
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={this.localizationService.strings.Messages_CancelPopup_No}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.myLinksStore.showCancelEditPopup = false;
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.myLinksStore.showCancelEditPopup = false;
              }}
            />
          }
        </div>
        <div id={`deletePopupId_${this.deletePopupId}`}>
          {this.props.myLinksStore.showDeletePopup &&
            <IAPopup
              headline={this.localizationService.strings.MyLinks_DeletePopupTitle}
              content={
                <div>
                  <IAButton
                    label={this.localizationService.strings.MyLinks_DeletePopupDeteleButton}
                    buttonColor={this.props.myLinksStore.highlightColor}
                    showSpinner={false}
                    onClick={() => {
                      this.props.myLinksStore.delete();
                      this.props.onChange();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={this.localizationService.strings.MyLinks_DeletePopupCancelButton}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.myLinksStore.showDeletePopup = false;
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.myLinksStore.showDeletePopup = false;
              }}
            />
          }
        </div>
        <EditPanel
          open={!!this.props.myLinksStore.itemToEdit}
          onSave={() => this.props.onChange()}
        />
        {this.props.myLinksStore.title &&
          <div
            className={'IA_WebpartHeader'}
            style={{
              marginBottom: 10,
              float: "left",
              fontFamily: this.props.myLinksStore.fontSlots?.heading?.fontFamily
            }}>
            <span role="heading" aria-level={2}>{this.props.myLinksStore.title}</span>
          </div>
        }
        {this.props.myLinksStore.collapseCommandBarItems &&
          <IASmallMenu
            menuItems={collapsedMenuItems}
            highlightColor={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.highlightColor}
            iconColor={Helper.isLightColor(this.props.myLinksStore.highlightColor) ? "#333333" : this.props.myLinksStore.highlightColor}
            onMenuItemClick={this.onMenuItemClick.bind(this)}
            styles={{
              marginLeft: "auto",
              marginBottom: 10,
              float: "right"
            }}
          />}
        {<IACommandBar
          style={this.props.myLinksStore.collapseCommandBarItems ? { float: "none" } : {}}
          highlightColor={this.props.myLinksStore.highlightColor}
          leftSideContent={this.props.myLinksStore.collapseCommandBarItems ? <div /> :
            <IAButton
              label={this.localizationService.strings.MyLinks_AddButton}
              buttonColor="transparent"
              textColor={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : "#333333"}
              icon="Add"
              height={22}
              iconColor={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.highlightColor}
              fontSize={14}
              dataAutomationId="mylinks-add-new"
              onClick={() => {
                this.props.myLinksStore.createNewItem();
              }}
              style={{
                float: "left",
                padding: 0
              }}
            />
          }
          rightSideContent={(this.props.myLinksStore.collapseCommandBarItems && this.props.myLinksStore.editMode) || (!this.props.myLinksStore.collapseCommandBarItems) ?
            <IAButton
                label={this.props.myLinksStore.editMode ? this.localizationService.strings.MyLinks_Save : this.localizationService.strings.MyLinks_EditButton}
                buttonColor="transparent"
                textColor={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : "#333333"}
                icon={this.props.myLinksStore.editMode ? "Save" : "Edit"}
                height={18}
                iconColor={this.props.myLinksStore.hasDarkBackground ? "#ffffff" : this.props.myLinksStore.highlightColor}
                fontSize={12}
                dataAutomationId="mylinks-add-new"
                onClick={() => {
                  this.props.myLinksStore.editMode = !this.props.myLinksStore.editMode;
                }}
                style={{
                  float: "left",
                  padding: 0
                }}
              /> : <div/>}
          showBar={true}
        />
        }
        <div className={styles.IA_myLinksContainer}>
          {myLinks}
        </div>
      </div>
    );
  }
}